export class AuthException extends Error {
  public readonly id: string;

  constructor(id: string = "errors.auth.general", message?: string) {
    super(message ?? "Authentication Error");

    this.id = id;
  }
}
